import { isBooleanTrue } from "../../../../../core/Type";
import { FrontSide, BackSide, DoubleSide } from "three";
export function updateMaterialSide(mat, params) {
  const singleSide = isBooleanTrue(params.front) ? FrontSide : BackSide;
  const newSide = isBooleanTrue(params.doubleSided) ? DoubleSide : singleSide;
  if (newSide != mat.side) {
    mat.side = newSide;
    mat.needsUpdate = true;
  }
  if (isBooleanTrue(params.overrideShadowSide)) {
    const singleSide2 = isBooleanTrue(params.shadowFront) ? FrontSide : BackSide;
    const newSide2 = isBooleanTrue(params.shadowDoubleSided) ? DoubleSide : singleSide2;
    if (newSide2 != mat.shadowSide) {
      mat.shadowSide = newSide2;
      mat.needsUpdate = true;
    }
  } else {
    mat.shadowSide = null;
  }
  const customMaterials = mat.customMaterials;
  if (customMaterials) {
    const customNames = Object.keys(customMaterials);
    for (let customName of customNames) {
      const customMaterial = customMaterials[customName];
      if (customMaterial) {
        updateMaterialSide(customMaterial, params);
      }
    }
  }
}
